import React from "react";

const items = [
  "AI Agents",
  "Enterprise RAG",
  "Cloud Native",
  "High-ROI Growth",
  "Legacy Modernization",
  "LLM Pipelines",
  "Digital Transformation",
  "Performance Marketing",
  "Custom Development",
  "Executive Advisory",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-banner"
      className="relative bg-[#0B0F19] border-y border-slate-800 py-5 overflow-hidden"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-mono-tech text-sm uppercase tracking-[0.28em] text-slate-400">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#F5A400] shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};
